module.exports = __webpack_public_path__ + "static/media/answer.9c7b262b.png";